import * as React from "react"
import { cn } from "../../lib/utils"
export interface TextareaProps
 extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
 ({ className, ...props }, ref) => {
 return (
 <textarea
 className={cn(
"flex min-h-[100px] w-full resize-y rounded-xl border border-border-subtle bg-background px-3 py-2 text-sm text-start ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground dark:bg-[hsl(var(--surface-elevated))] dark:ring-offset-card transition-shadow duration-150",
 className
 )}
 ref={ref}
 {...props}
 />
 )
 }
)
Textarea.displayName ="Textarea"
export { Textarea }
